<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit Sub-Category</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>

    <mat-card-content>
      <form [formGroup]="editSubCategoryForm" (ngSubmit)="saveSubCategory()" novalidate>
        <div class="row">
          <!-- Product -->
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>Product</mat-label>
              <mat-select
                (selectionChange)="onSelectionchange($event)"
                formControlName="productId"
                required
                [disabled]="productOptions.length === 0"
              >
                <mat-option [value]="null" *ngIf="productOptions.length > 0">Select an option</mat-option>
                <mat-option *ngIf="productOptions.length === 0" disabled>Loading...</mat-option>
                <mat-option
                  *ngFor="let product of productOptions; let i = index"
                  [value]="product.productId"
                >
                  {{ product.productName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="editSubCategoryForm.get('productId')?.hasError('required')">
                Product is required.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Category -->
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>Category</mat-label>
              <mat-select
                formControlName="categoryId"
                required
                [disabled]="categoryOptions.length === 0"
              >
                <mat-option [value]="null" *ngIf="categoryOptions.length > 0">Select an option</mat-option>
                <mat-option *ngIf="categoryOptions.length === 0" disabled>Loading...</mat-option>
                <mat-option *ngFor="let cat of categoryOptions" [value]="cat.categoryId">
                  {{ cat.productCategoryName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="editSubCategoryForm.get('categoryId')?.hasError('required')">
                Category is required.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <!-- Sub-Category Name -->
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>Sub-Category Name</mat-label>
              <input
                matInput
                type="text"
                name="subCategoryName"
                formControlName="subCategoryName"
                required
                [placeholder]="'SubCategory Name'"
                appInputValidator
                [sanitizeScriptTags]="true"
                [hasAtLeastOneAlphabet]="true"
              />
              <mat-error *ngIf="editSubCategoryForm.get('subCategoryName')?.hasError('required')">
                Sub Category Name is required.
              </mat-error>
              <mat-error *ngIf="editSubCategoryForm.get('subCategoryName')?.hasError('maxlength')">
                Sub Category Name cannot be more than 50 characters.
              </mat-error>
              <mat-error *ngIf="editSubCategoryForm.get('subCategoryName')?.hasError('noAlphabet')">
                Must contain at least one alphabet.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Description -->
          <div class="col-md-6">
            <mat-form-field color="accent">
              <mat-label>Description</mat-label>
              <input
                matInput
                type="text"
                name="description"
                formControlName="description"
                required
                [placeholder]="'Description'"
                autocomplete="off"
                appInputValidator
                [sanitizeScriptTags]="true"
                [hasAtLeastOneAlphabet]="true"
              />
              <mat-error *ngIf="editSubCategoryForm.get('description')?.hasError('required')">
                Description is required.
              </mat-error>
              <mat-error *ngIf="editSubCategoryForm.get('description')?.hasError('maxlength')">
                Must contain only 100 characters.
              </mat-error>
              <mat-error *ngIf="editSubCategoryForm.get('description')?.hasError('noAlphabet')">
                Must contain at least one alphabet.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>

    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="row action-btn">
          <button md-raised-button type="button" class="btn btn-rose" (click)="close()">Close</button>
          <button
            md-raised-button
            type="button"
            class="btn btn-rose"
            (click)="saveSubCategory()"
            [disabled]="
              !editSubCategoryForm.valid ||
              !editSubcategory.productId ||
              !editSubcategory.categoryId ||
              categoryOptions.length === 0 ||
              editSubcategory.categoryId === 0
            "
          >
            Update
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
